/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ConversationSummaryOutStatus = typeof ConversationSummaryOutStatus[keyof typeof ConversationSummaryOutStatus];


export const ConversationSummaryOutStatus = {
  pending: 'pending',
  ready: 'ready',
  failed: 'failed',
} as const;
